import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const sportsRootInitialState: SportsRootState = {
  favouriteSports: [],
  favouriteCompetitions: [],
}

const sportsRootSlice = createSlice({
  name: 'sports-root',
  initialState: sportsRootInitialState,
  reducers: {
    toggleSportsFavourite(state, { payload }: PayloadAction<string>) {
      if (state.favouriteSports.includes(payload)) {
        state.favouriteSports = state.favouriteSports.filter(item => item !== payload)
      } else {
        state.favouriteSports.push(payload)
      }
    },

    toggleCompetitionFavourite(state, { payload }: PayloadAction<string>) {
      if (state.favouriteCompetitions.includes(payload)) {
        state.favouriteCompetitions = state.favouriteCompetitions.filter(item => item !== payload)
      } else {
        state.favouriteCompetitions.push(payload)
      }
    },
  },
})

export const { toggleSportsFavourite, toggleCompetitionFavourite } =
  sportsRootSlice.actions

export default persistReducer(
  {
    key: 'sports-root',
    storage,
    debug: !PRODUCTION,
    whitelist: ['favouriteSports', 'favouriteCompetitions'],
  },
  sportsRootSlice.reducer
)

// =====
// Types
// =====

export interface SportsRootState {
  favouriteSports: string[]
  favouriteCompetitions: string[]
}
